import { render, staticRenderFns } from "./AddUserComponent.vue?vue&type=template&id=2fd539e2&"
import script from "./AddUserComponent.vue?vue&type=script&lang=js&"
export * from "./AddUserComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports